import { OktaAuth } from '@okta/okta-auth-js/core';

import { wrapOkta, type AuthClient } from './client';
import { oktaOptions, type AuthSettings } from './settings';

/**
 * The real client (CHG-050). It is the only place `OktaAuth` is built; tests use `FakeAuth`.
 * `restoreOriginalUri` replaces Okta's own page reload after the callback: the console routes to
 * the page itself, so it only records which page that is.
 */
export function createOktaClient(settings: AuthSettings): AuthClient {
  let restored: string | undefined;
  const okta = new OktaAuth({
    ...oktaOptions(settings, window.location.origin),
    restoreOriginalUri: (_okta, originalUri) => {
      restored = originalUri;
      return Promise.resolve();
    },
  });
  // `start` runs the services behind autoRenew; a failure to start is no reason to stay signed out.
  okta.start().catch((error: unknown) => console.error('Okta did not start.', error));
  return wrapOkta(okta, { restoredUri: () => restored, origin: window.location.origin });
}
